export class Logger {
	public static namespace(name: string): Logger {
		return new Logger(`[${name}]`);
	}

	private constructor(private readonly name: string) {}

	public trace(msg: string, ...params: Array<unknown>): void {
		// biome-ignore lint/suspicious/noConsole: logger uses console under the hood
		console.trace(this.name, msg, ...params);
	}

	public debug(msg: string, ...params: Array<unknown>): void {
		if (import.meta.env.DEV) {
			// biome-ignore lint/suspicious/noConsole: logger uses console under the hood
			console.debug(this.name, msg, ...params);
		}
	}

	public info(msg: string, ...params: Array<unknown>): void {
		// biome-ignore lint/suspicious/noConsole: logger uses console under the hood
		console.info(this.name, msg, ...params);
	}

	public warn(msg: string, ...params: Array<unknown>): void {
		// biome-ignore lint/suspicious/noConsole: logger uses console under the hood
		console.warn(this.name, msg, ...params);
	}

	public error(msg: string | Error, ...params: Array<unknown>): void {
		// biome-ignore lint/suspicious/noConsole: logger uses console under the hood
		console.error(this.name, msg, ...params);
	}

	public perf<TValue>(msg: string, execute: () => TValue): TValue {
		const startTime = performance.now();
		const value = execute();

		this.debug(this.name, `${msg}: ${performance.now() - startTime}ms`);

		return value;
	}
}
